import React from 'react';
import { Alert, Box, Typography } from '@mui/material';


const ExclusiveDatasetModeAlert = ({ violationMsg, rampIdDatasets, piiDatasets }) => (
  <Alert
    severity='error'
    sx={{
      p: 2,
      '& .MuiAlert-message': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      },
      alignItems: 'unset',
    }}
  >
    <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1 }}>
      {violationMsg}
    </Typography>
    <Box component='ul' sx={{ pl: 2, m: 0 }}>
      <li>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          List of RampID Datasets
        </Typography>
        <Box component='ul' sx={{ pl: 2, m: 0 }}>
          {rampIdDatasets.map((dataset) => (
            <li key={dataset}>
              <Typography variant='body1'>{dataset}</Typography>
            </li>
          ))}
        </Box>
      </li>
      <li>
        <Typography variant='body1' sx={{ fontWeight: 'bold' }}>
          List of PII Datasets
        </Typography>
        <Box component='ul' sx={{ pl: 2, m: 0 }}>
          {piiDatasets.map((dataset) => (
            <li key={dataset}>
              <Typography variant='body1'>{dataset}</Typography>
            </li>
          ))}
        </Box>
      </li>
    </Box>
  </Alert>
);

export default ExclusiveDatasetModeAlert;

